const { h, render, Component } = require('preact');
const ID = require('./id')
const PurchaseDate = require('./purchase_date')
const Status = require('./status')
const ExpiryDate = require('./expiry_date')
const Gift = require('./gift')
const Quantity = require('./quantity')
const LocalGoodsTable = require('./local_goods_table')
const CheckInInfo = require('./check_in_info')
const CheckOutInfo = require('./check_out_info')

class GetawaysVoucherTable extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let extraInfo = null;
    if(lodash.has(this.props.orderDetails, 'this.props.orderDetails.groupons[0].extraAttributes'))
      extraInfo = this.props.orderDetails.groupons[0].extraAttributes;
    if (extraInfo || lodash.has(this.props.orderDetails, 'travelBookingInfo')){
      return (
        <table class="first-table">
          <ID orderDetails={this.props.orderDetails}/>
          <PurchaseDate orderDetails={this.props.orderDetails}/>
          {extraInfo && extraInfo.roomTypeName && extraInfo.roomTypeName.length > 0 &&
            <tr>
              <td>{I18n.translate("js.modules.web_2018.room")}:</td>
              <td>{extraInfo.roomTypeName}</td>
            </tr>
          }
          {extraInfo && extraInfo.numberOfAdults && extraInfo.numberOfAdults != "0" &&
            <tr>
              <td>{I18n.translate("js.modules.web_2018.no_of_adults")}:</td>
              <td>{extraInfo.numberOfAdults}</td>
            </tr>
          }
          {extraInfo && extraInfo.numberOfChildren && extraInfo.numberOfChildren != "0" &&
            <tr>
              <td>{I18n.translate("js.modules.web_2018.no_of_children")}:</td>
              <td>{extraInfo.numberOfChildren}</td>
            </tr>
          }
          <CheckInInfo orderDetails={this.props.orderDetails}/>
          <CheckOutInfo orderDetails={this.props.orderDetails}/>
          <ExpiryDate orderDetails={this.props.orderDetails}/>
          <Gift orderDetails={this.props.orderDetails}/>
          <Quantity orderDetails={this.props.orderDetails}/>
        </table>
      );
    }
    return (
      <LocalGoodsTable orderDetails={this.props.orderDetails}/>
    );
  }
}
module.exports = GetawaysVoucherTable
